import { Component, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ConsentFormService } from './consentForm.service';
import { Member } from 'src/app/model/member.model';
import { ScrollPanel } from 'primeng/scrollpanel';
import { ConsentForm } from 'src/app/model/consentForm.model';
import { environment } from 'src/environments/environment';
import { NgxSignatureOptions, NgxSignaturePadComponent } from '@eve-sama/ngx-signature-pad';

@Component({
  selector: 'app-consentForm',
  templateUrl: './consentForm.component.html',
  styleUrl: './consentForm.component.css'
})
export class ConsentFormComponent {
  /** 同意書Scroll */
  @ViewChild('consentFormScrollPanel') public scrollPanel: ScrollPanel;
  @ViewChild('sig', { static: false }) pad!: NgxSignaturePadComponent;
  options: NgxSignatureOptions = {
      backgroundColor: '#fff',
      width: 500,
      height: 500
  };
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  LoginUser: Member;
  activeIndex: number = 0;
  editModel: ConsentForm[] = [];
  drawData: ConsentForm;
  /**畫面載入 */
  isOptionLoading: boolean = false;
  loading: boolean = false;
  baseUrl = environment.baseUrl;
  showDialog = false;
  subscribes: Subscription = new Subscription();
  constructor(
        private route: ActivatedRoute,
        private ConsentFormService: ConsentFormService,
        private authenticationService: AuthenticationService
  ){}
  ngOnInit(): void {
      var that = this;
      // 取得querystring param
      var query = this.route.queryParams.subscribe((value) => {
        this.CompanyID = value['CompanyID'];
        this.UserID = value['UserID'];
        this.Liff_ID = value['Liff_ID'];
      });

      var currentUser = this.authenticationService.currentMember.subscribe(
        (member) => {
          this.LoginUser = member;
        }
      );

      this.subscribes.add(query);
      this.subscribes.add(currentUser);
      
      this.subscription();
  }

  //#region   初始化設定
      /**取得門市與服務項目 */
      subscription() {
        this.isOptionLoading = true;
        var subject = new BehaviorSubject<boolean>(false);
        //取得門市與服務項目
        var GetDefaultData = this.ConsentFormService.SearchConsentFormData(
          this.CompanyID,
          this.UserID
        ).subscribe((res) => {
          if (res.ErrorFlag == "1") {
            Swal.fire({
              icon: 'error',
              title: res.ErrorMsg,
            });
          } else {
            this.getDataSucceed(res);
            subject.next(true);
            subject.complete();
          }
        });
        this.subscribes.add(GetDefaultData);
        return subject.asObservable();
      }
  //#endregion
  //#region   相關事件
      getDataSucceed(res: any) { 
          this.editModel = res;
          this.editModel.forEach(e=>{
              if(!!e.SignPath){
                var times = new Date(e.SignatureTime);
                e.consentFormContent = e.consentFormContent.replace(/(日期)([:：]?\s*)(.*?)(\r?\n|$)/, `$1: ${times.toLocaleDateString()}`);
              }
          });
          this.isOptionLoading = false;
      }
      /**簽名 */
      Sign(data: ConsentForm) {
          this.showDialog = true;
          this.drawData = data;
      }
      /**清除簽名
        */
      clear() {
          this.pad.clear();
      }
      /**儲存簽名 */
      save() {
            if (this.pad.isEmpty()) {
              alert('請先簽名');
              return;
            }
            const dataURL = this.pad.toDataURL();
            this.drawData.SignPath = dataURL;
            this.loading = true;
            this.ConsentFormService.SaveSign(this.drawData).subscribe((res: any)=>{ 
              this.showDialog = false;
              if(res.ErrorFlag == "1")
              {
                Swal.fire({
                        icon: 'error',
                        title: res.ErrorMsg
                      });
              }
              //取得該筆明細資料
              var target = this.editModel.find(s=>
                s.Type == this.drawData.Type
              );
              if(!!target)
              {
                this.drawData.SignPath = res.SignatureImagePath;
                target.SignPath = res.SignatureImagePath;
                target.SignatureTime = new Date();
              }
              this.loading = false;
              //最後記得清除
              this.pad.clear();
            });
      }
      onBegin() { /* 開始簽名事件 */ }
      onEnd() { /* 結束簽名事件 */ }
  //#endregion

  ngOnDestroy() {
    this.subscribes.unsubscribe();
  }
}
